import type { AccountListQuery, DropListQuery, OrderListQuery, Retailer } from '@nebueye/shared'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { api, timeZone } from './api'

/** Public, no session: whether sign-up is open or invite-only, and the Turnstile site key when the API demands a captcha token. */
export const configQuery = () =>
  queryOptions({
    queryKey: ['config'],
    queryFn: async ({ signal }) => {
      const res = await fetch('/api/config', { signal })
      if (!res.ok) throw new Error(`config: ${res.status}`)
      return (await res.json()) as { signups: 'open' | 'invite'; turnstileSiteKey: string | null }
    },
    staleTime: 5 * 60_000,
  })

export const dashboardQuery = (days: number) =>
  queryOptions({
    queryKey: ['dashboard', days, timeZone],
    queryFn: ({ signal }) => api.dashboard({ days, tz: timeZone }, signal),
    placeholderData: keepPreviousData,
  })

export const ordersQuery = (q: OrderListQuery) =>
  queryOptions({
    queryKey: ['orders', q],
    queryFn: ({ signal }) => api.orders(q, signal),
    placeholderData: keepPreviousData,
  })

export const orderQuery = (orderNumber: string, retailer?: Retailer) =>
  queryOptions({
    queryKey: ['order', orderNumber, retailer],
    queryFn: ({ signal }) => api.order(orderNumber, retailer, signal),
  })

export const incomingQuery = () =>
  queryOptions({
    queryKey: ['incoming', timeZone],
    queryFn: ({ signal }) => api.incoming({ tz: timeZone }, signal),
  })

export const dropsQuery = (q: DropListQuery) =>
  queryOptions({
    queryKey: ['drops', q],
    queryFn: ({ signal }) => api.drops(q, signal),
    placeholderData: keepPreviousData,
  })

export const dropQuery = (id: string) =>
  queryOptions({ queryKey: ['drop', id], queryFn: ({ signal }) => api.drop(id, signal) })

export const accountsQuery = (q: AccountListQuery) =>
  queryOptions({
    queryKey: ['accounts', q],
    queryFn: ({ signal }) => api.accounts(q, signal),
    placeholderData: keepPreviousData,
  })
